// extracted by mini-css-extract-plugin
module.exports = {"warning":"ScreenNameForm_warning__3V1Fr","input":"ScreenNameForm_input__MwPtw","form":"ScreenNameForm_form__24s8b"};